import { Injectable } from '@angular/core';
import {ReplaySubject, Subject} from "rxjs";

@Injectable({providedIn:'root'})
export class CardEventsService {
  private _saved$ = new ReplaySubject<boolean>(1);
  saved$ = this._saved$.asObservable();

  notifySaved(success: boolean) {
    this._saved$.next(success);
  }

  clearSaved() {
    this._saved$ = new ReplaySubject<boolean>(1);
    this.saved$ = this._saved$.asObservable();
  }
}
